import { FC } from 'react';
import { useLocation } from 'react-router-dom';

import { useUserContext } from '@/contexts/user';
import { getLoginUrl } from '@/lib/dmm/accounts';

import { RegisterLink, SigninLink } from './style';

export const signinPath = '/signup';

const NonMember: FC = () => {
  const { isGuest, isLoggedIn } = useUserContext();
  const location = useLocation();

  if (location.pathname.includes(signinPath)) {
    return null;
  }

  if (isGuest && !isLoggedIn) {
    return <SigninLink href={getLoginUrl()}>ログイン</SigninLink>;
  }

  if (isGuest && isLoggedIn) {
    return <RegisterLink to={signinPath}>利用登録</RegisterLink>;
  }

  return null;
};

export default NonMember;
